export default {
  REQUEST_FETCH_SELECTED_ARTICLE: 'REQUEST_FETCH_SELECTED_ARTICLE',
  FETCH_SELECTED_ARTICLE_SUCCESS: 'FETCH_SELECTED_ARTICLE_SUCCESS',
  FETCH_SELECTED_ARTICLE_ERROR: 'FETCH_SELECTED_ARTICLE_ERROR'
}
